var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconV = function SvgIconV(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.5 2.95 6 7 1.5",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    "data-no-fill": "true"
  })));
};
export { SvgIconV as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPHBhdGgKICAgICAgICBkPSJNMSA0LjVMMi45NSA2TDcgMS41IgogICAgICAgIHN0cm9rZT0iIzAwMCIKICAgICAgICBzdHJva2Utd2lkdGg9IjEuNSIKICAgICAgICBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgICAgICAgZGF0YS1uby1maWxsPSJ0cnVlIgogICAgLz4KPC9zdmc+Cg==";